import { IErrorMessage } from '@shared/hooks/use-error-message';
import {
  DevicesRowDataProps,
  GroupedDevicesModel
} from '@modules/digital-signage/model/devices.model';

export const playlistErrorMessages: IErrorMessage = {
  name: {
    required: 'validation_name_required',
    notOnlySpaces: 'validation_notOnly_spaces_required'
  }
};

export const deviceGroupErrorMessages: IErrorMessage = {
  name: {
    required: 'validation_name_required',
    notOnlySpaces: 'validation_notOnly_spaces_required'
  }
};

export const screensErrorMessages: IErrorMessage = {
  title: {
    required: 'validation_title_required',
    notOnlySpaces: 'validation_notOnly_spaces_required'
  },
  mediaUrl: {
    pattern: 'validation_url_pattern'
  }
};

export const digitalSignageCodeErrorMessages: IErrorMessage = {
  code: {
    required: 'validation_code_required',
    notOnlySpaces: 'validation_notOnly_spaces_required'
  }
};

export const convertToSelectedAssignScreen = (
  data: any | null
): { id: number; title: string; value: string }[] => {
  if (!data || !data.screen) return [];

  const { _id, title } = data.screen;

  return [
    {
      id: _id,
      title,
      value: title
    }
  ];
};

export const digitalSignageAddScreenErrorMessages: IErrorMessage = {
  assignScreen: {
    required: 'validation_assign_screen_required'
  }
};

export const moveToGroupErrorMessages: IErrorMessage = {
  deviceGroup: {
    required: 'validation_device_group_required'
  }
};

// A group carrying the defaultDevice key is a technical one, auto-created for
// a single device, so such a device is not assigned to any real group.
const isInRealDeviceGroup = (device: DevicesRowDataProps): boolean =>
  !!device.deviceGroup?.name && device.deviceGroup.defaultDevice === undefined;

export const getDeviceKey = (device: DevicesRowDataProps): string =>
  (device.deviceId ?? device._id ?? device.name) as string;

export const groupDevicesByCurrentGroup = (
  devices: DevicesRowDataProps[]
): GroupedDevicesModel[] => {
  const groups = new Map<string, GroupedDevicesModel>();

  devices.filter(isInRealDeviceGroup).forEach((device) => {
    const groupId = device.deviceGroup?._id as string;
    const group = groups.get(groupId);

    if (group) {
      group.devices.push(device);
      return;
    }

    groups.set(groupId, {
      groupId,
      groupName: device.deviceGroup?.name as string,
      devices: [device]
    });
  });

  return Array.from(groups.values());
};

// Turns one group's local selection into the next overall list of devices to
// move. Rebuilding it by filtering the source devices keeps their order, the
// other groups' devices and the devices that isInRealDeviceGroup filters out
// (they are never shown in the alert but always belong to the payload).
export const applyGroupDevicesSelection = (
  sourceDevices: DevicesRowDataProps[],
  selectedDevices: DevicesRowDataProps[],
  groupDevices: DevicesRowDataProps[],
  nextGroupDevices: DevicesRowDataProps[]
): DevicesRowDataProps[] => {
  const keys = new Set(selectedDevices.map(getDeviceKey));

  groupDevices.forEach((device) => keys.delete(getDeviceKey(device)));
  nextGroupDevices.forEach((device) => keys.add(getDeviceKey(device)));

  return sourceDevices.filter((device) => keys.has(getDeviceKey(device)));
};

export const eventErrorMessages: IErrorMessage = {
  name: {
    required: 'validation_name_required',
    notOnlySpaces: 'validation_notOnly_spaces_required'
  },
  location: {
    required: 'validation_location_required',
    notOnlySpaces: 'validation_notOnly_spaces_required'
  },
  startDateTime: {
    required: 'validation_start_date_required'
  },
  categories: {
    required: 'validation_categories_required'
  }
};

export const mediaTypeFilterData = [
  {
    title: 'Image',
    value: 'image'
  },
  {
    title: 'Video',
    value: 'video'
  },
  {
    title: 'Html',
    value: 'html'
  }
];

export const digitalSignageScreensTabsData = [
  { label: 'tab_label_file', value: 'file' },
  { label: 'tab_label_url', value: 'url' },
  { label: 'tab_label_app_path', value: 'appPath' }
];
